import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-block fw-normal fs-6 text-body-secondary mt-1" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_5 = { class: "d-block mb-1" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "nav nav-tabs mb-3"
}
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "badge rounded-pill text-bg-secondary ms-1" }
const _hoisted_11 = {
  key: 1,
  class: "d-grid gap-2"
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "flex-grow-1" }
const _hoisted_14 = { class: "fw-semibold d-block" }
const _hoisted_15 = {
  key: 0,
  class: "small text-body-secondary"
}
const _hoisted_16 = { class: "small fw-semibold text-body-secondary mb-2" }
const _hoisted_17 = { class: "list-group" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "flex-grow-1" }
const _hoisted_20 = { class: "row row-cols-1 row-cols-sm-2 g-2" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "flex-grow-1" }
const _hoisted_23 = { class: "fw-semibold d-block" }
const _hoisted_24 = { class: "small text-body-secondary" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "flex-grow-1 small" }
const _hoisted_27 = { class: "d-block" }
const _hoisted_28 = ["href"]
const _hoisted_29 = {
  key: 4,
  class: "small text-body-secondary mt-3 mb-0"
}
const _hoisted_30 = ["href"]
const _hoisted_31 = {
  key: 2,
  class: "text-center py-5"
}
const _hoisted_32 = { class: "text-body-secondary mb-4" }
const _hoisted_33 = { class: "small text-body-secondary" }
const _hoisted_34 = { key: 3 }
const _hoisted_35 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_36 = { class: "text-body-secondary mb-3" }
const _hoisted_37 = { class: "d-flex align-items-center mb-3" }
const _hoisted_38 = { class: "small text-body-secondary" }
const _hoisted_39 = { class: "alert alert-warning mb-0 py-2 small" }
const _hoisted_40 = { class: "mb-0 ps-3" }
const _hoisted_41 = {
  key: 4,
  class: "text-center py-5"
}
const _hoisted_42 = {
  key: 0,
  class: "small text-body-secondary me-auto"
}
const _hoisted_43 = {
  key: 1,
  class: "small text-body-secondary me-auto"
}
const _hoisted_44 = {
  key: 3,
  type: "button",
  class: "btn btn-link text-body-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_45 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    ref: "dialog",
    size: "lg",
    onHidden: _ctx.cancel
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
      _createElementVNode("small", _hoisted_1, _toDisplayString(_ctx.subject), 1)
    ]),
    body: _withCtx(() => [
      (_ctx.state === 'loading')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("i", { class: "fas fa-circle-notch fa-spin fa-lg text-body-secondary" }, null, -1)
          ]))]))
        : (_ctx.state === 'choosing')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.options.templates.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Pro tento odhad teď není k dispozici žádná šablona. "))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (notice) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: notice.title,
                        class: "alert alert-danger py-2 small"
                      }, [
                        _createElementVNode("strong", _hoisted_5, _toDisplayString(notice.title), 1),
                        _createTextVNode(_toDisplayString(notice.message), 1)
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.confirmations, (notice) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: notice.title,
                        class: "d-flex border rounded p-2 small mb-2 cursor-pointer"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.confirmed) = $event)),
                          type: "checkbox",
                          class: "form-check-input mt-0 me-2 flex-shrink-0",
                          value: notice
                        }, null, 8, _hoisted_6), [
                          [_vModelCheckbox, _ctx.confirmed]
                        ]),
                        _createTextVNode(" " + _toDisplayString(notice.message), 1)
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.informations, (notice) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: notice.title,
                        class: "small text-body-secondary mb-3"
                      }, [
                        _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fas fa-info-circle me-1" }, null, -1)),
                        _createTextVNode(_toDisplayString(notice.message), 1)
                      ]))
                    }), 128)),
                    (_ctx.composedTemplates.length > 0 && _ctx.pdfTemplates.length > 0)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                          _createElementVNode("li", _hoisted_8, [
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["nav-link", {active: !_ctx.isPdfTabActive}]),
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openTab(_ctx.composedTemplates)))
                            }, "Nové šablony", 2)
                          ]),
                          _createElementVNode("li", _hoisted_9, [
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["nav-link", {active: _ctx.isPdfTabActive}]),
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openTab(_ctx.pdfTemplates)))
                            }, [
                              _cache[14] || (_cache[14] = _createTextVNode(" PDF šablony ", -1)),
                              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.pdfTemplates.length), 1)
                            ], 2)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isPdfTabActive)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.composedTemplates, (template) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: template.id,
                              class: _normalizeClass(["border rounded p-3 d-flex align-items-center mb-0 cursor-pointer", {'border-primary': template.id === _ctx.templateId}])
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.templateId) = $event)),
                                type: "radio",
                                name: "document-template",
                                class: "form-check-input mt-0 me-3 flex-shrink-0",
                                value: template.id
                              }, null, 8, _hoisted_12), [
                                [_vModelRadio, _ctx.templateId]
                              ]),
                              _createElementVNode("span", _hoisted_13, [
                                _createElementVNode("span", _hoisted_14, _toDisplayString(template.title), 1),
                                (template.description !== null)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(template.description), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ], 2))
                          }), 128))
                        ]))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.pdfGroups, (group, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: group.title,
                            class: _normalizeClass({'mt-3': index > 0})
                          }, [
                            _createElementVNode("div", _hoisted_16, _toDisplayString(group.title), 1),
                            _createElementVNode("div", _hoisted_17, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.templates, (template) => {
                                return (_openBlock(), _createElementBlock("label", {
                                  key: template.id,
                                  class: "list-group-item list-group-item-action d-flex align-items-center cursor-pointer"
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.templateId) = $event)),
                                    type: "radio",
                                    name: "document-template",
                                    class: "form-check-input mt-0 me-3 flex-shrink-0",
                                    value: template.id
                                  }, null, 8, _hoisted_18), [
                                    [_vModelRadio, _ctx.templateId]
                                  ]),
                                  _createElementVNode("span", _hoisted_19, _toDisplayString(template.title), 1),
                                  _cache[15] || (_cache[15] = _createElementVNode("i", { class: "far fa-file-pdf text-body-secondary ms-2" }, null, -1))
                                ]))
                              }), 128))
                            ])
                          ], 2))
                        }), 128)),
                    (_ctx.selectedTemplate !== null && _ctx.selectedTemplate.formats.length > 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "small fw-semibold text-body-secondary mt-3 mb-2" }, "Formát", -1)),
                          _createElementVNode("div", _hoisted_20, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formatOptions, (option) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: option.format,
                                class: "col"
                              }, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(["border rounded px-3 py-2 d-flex align-items-center mb-0 h-100 cursor-pointer", {'border-primary': option.format === _ctx.format}])
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.chosenFormat) = $event)),
                                    type: "radio",
                                    name: "document-format",
                                    class: "form-check-input mt-0 me-3 flex-shrink-0",
                                    value: option.format
                                  }, null, 8, _hoisted_21), [
                                    [_vModelRadio, _ctx.chosenFormat]
                                  ]),
                                  _createElementVNode("span", _hoisted_22, [
                                    _createElementVNode("span", _hoisted_23, _toDisplayString(option.title), 1),
                                    _createElementVNode("span", _hoisted_24, _toDisplayString(option.description), 1)
                                  ]),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["far fa-lg text-body-secondary ms-2", option.icon])
                                  }, null, 2)
                                ], 2)
                              ]))
                            }), 128))
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warnings, (notice) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: notice.title,
                        class: "alert alert-warning d-flex flex-wrap align-items-center mt-3 mb-0 py-2"
                      }, [
                        (notice.imageUrl !== null)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: notice.imageUrl,
                              alt: "",
                              width: "72",
                              height: "54",
                              class: "rounded bg-white object-fit-cover me-3 flex-shrink-0 d-none d-sm-block"
                            }, null, 8, _hoisted_25))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("strong", _hoisted_27, _toDisplayString(notice.title), 1),
                          _createTextVNode(_toDisplayString(notice.message), 1)
                        ]),
                        (_ctx.photosUrl !== '' && notice.imageUrl !== null)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: _ctx.photosUrl,
                              class: "btn btn-outline-primary btn-sm ms-sm-3 mt-2 mt-sm-0 flex-shrink-0"
                            }, "Přidat fotografie", 8, _hoisted_28))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    (!_ctx.options.isLicensed && _ctx.licenseUrl !== '')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
                          _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fas fa-info-circle me-1" }, null, -1)),
                          _cache[18] || (_cache[18] = _createTextVNode("Podrobný a zjednodušený odhad jsou součástí předplatného. ", -1)),
                          _createElementVNode("a", { href: _ctx.licenseUrl }, "Zobrazit možnosti", 8, _hoisted_30)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
            ]))
          : (_ctx.state === 'generating')
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "h5 mb-1" }, "Připravujeme dokument", -1)),
                _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.selectedTemplate?.title) + ", " + _toDisplayString(_ctx.format === 'docx' ? 'Word (DOCX)' : 'PDF'), 1),
                _cache[20] || (_cache[20] = _createElementVNode("div", {
                  class: "progress mx-auto w-75 mb-3",
                  style: {"height":"6px"}
                }, [
                  _createElementVNode("div", { class: "progress-bar progress-bar-striped progress-bar-animated w-100" })
                ], -1)),
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.isTakingLong ? 'Ještě chvíli, tento dokument trvá déle než obvykle.' : 'Vkládáme mapy, grafy a fotografie. Obvykle to trvá do 10 sekund.'), 1)
              ]))
            : (_ctx.state === 'done' && _ctx.document !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  (_ctx.document.missingParts.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _cache[22] || (_cache[22] = _createElementVNode("div", {
                          class: "rounded-circle d-inline-flex align-items-center justify-content-center text-bg-success mb-3",
                          style: {"width":"56px","height":"56px"}
                        }, [
                          _createElementVNode("i", { class: "fas fa-check fa-lg" })
                        ], -1)),
                        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "h5 mb-1" }, "Stažení proběhlo", -1)),
                        _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.document.fileName) + ", " + _toDisplayString(_ctx.fileSize), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-primary btn-sm",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                        }, [...(_cache[21] || (_cache[21] = [
                          _createElementVNode("i", { class: "fas fa-download me-2" }, null, -1),
                          _createTextVNode("Stáhnout znovu ", -1)
                        ]))])
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_37, [
                          _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fas fa-check-circle text-success fa-2x me-3" }, null, -1)),
                          _createElementVNode("div", null, [
                            _cache[24] || (_cache[24] = _createElementVNode("strong", { class: "d-block" }, "Stažení proběhlo", -1)),
                            _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.document.fileName) + ", " + _toDisplayString(_ctx.fileSize), 1)
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-outline-primary btn-sm ms-auto",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                          }, [...(_cache[25] || (_cache[25] = [
                            _createElementVNode("i", { class: "fas fa-download me-2" }, null, -1),
                            _createTextVNode("Stáhnout znovu ", -1)
                          ]))])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _cache[27] || (_cache[27] = _createElementVNode("strong", { class: "d-block mb-1" }, "V dokumentu chybí", -1)),
                          _createElementVNode("ul", _hoisted_40, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.document.missingParts, (part) => {
                              return (_openBlock(), _createElementBlock("li", { key: part }, _toDisplayString(part), 1))
                            }), 128))
                          ])
                        ])
                      ], 64))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_41, [...(_cache[28] || (_cache[28] = [
                  _createElementVNode("div", {
                    class: "rounded-circle d-inline-flex align-items-center justify-content-center text-bg-danger mb-3",
                    style: {"width":"56px","height":"56px"}
                  }, [
                    _createElementVNode("i", { class: "fas fa-exclamation-circle fa-lg" })
                  ], -1),
                  _createElementVNode("div", { class: "h5 mb-1" }, "Dokument se nepodařilo vytvořit", -1),
                  _createElementVNode("div", { class: "text-body-secondary" }, "Chybu už řešíme. Odhad zůstal beze změny, můžete to zkusit znovu.", -1)
                ]))]))
    ]),
    buttons: _withCtx(() => [
      (_ctx.state === 'choosing' && _ctx.options.templates.length > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_42, "Stažením se odhad označí jako dokončený."))
        : (_ctx.state === 'done')
          ? (_openBlock(), _createElementBlock("span", _hoisted_43, "Odhad je označený jako dokončený."))
          : _createCommentVNode("", true),
      (_ctx.state === 'generating')
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            class: "btn btn-link text-body-secondary",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
          }, "Zrušit"))
        : (_openBlock(), _createElementBlock("button", _hoisted_44, "Zavřít")),
      (_ctx.state === 'choosing' && _ctx.options.templates.length > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 4,
            type: "button",
            class: "btn btn-primary px-3",
            disabled: !_ctx.isDownloadable,
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.generate && _ctx.generate(...args)))
          }, [...(_cache[29] || (_cache[29] = [
            _createElementVNode("i", { class: "fas fa-download me-2" }, null, -1),
            _createTextVNode("Stáhnout dokument ", -1)
          ]))], 8, _hoisted_45))
        : (_ctx.state === 'done')
          ? (_openBlock(), _createElementBlock("button", {
              key: 5,
              type: "button",
              class: "btn btn-primary px-3",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.state = 'choosing'))
            }, _toDisplayString(_ctx.document !== null && _ctx.document.missingParts.length > 0 ? 'Vytvořit znovu' : 'Vytvořit jiný dokument'), 1))
          : (_ctx.state === 'failed')
            ? (_openBlock(), _createElementBlock("button", {
                key: 6,
                type: "button",
                class: "btn btn-primary px-3",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.retry && _ctx.retry(...args)))
              }, [...(_cache[30] || (_cache[30] = [
                _createElementVNode("i", { class: "fas fa-redo me-2" }, null, -1),
                _createTextVNode("Zkusit znovu ", -1)
              ]))]))
            : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onHidden"]))
}